import type { ComponentType } from "react";
import { useMemo } from "react";
import { useQuery } from "react-query";
import type { NearMeFilterConfiguration } from "@/react/components/FilterKit/types";
import { crmFiltersApi } from "../api/crmFiltersApi";
import { NearMe } from "../components/shared/MemberFilters/SharedFilters/NearMe";
import type { RenderFilter } from "../components/shared/MemberFilters/types";
import { useCrmTrueLocationFieldAndSearchEnabled } from "../components/shared/MemberFilters/useCrmLocationEnabled";

const crmFilterComponents: Record<
  NearMeFilterConfiguration["input_type"],
  ComponentType<any>
> = {
  near_me: NearMe,
};

export const useCrmFilters = () =>
  useQuery({
    queryKey: ["crmFilters"],
    queryFn: crmFiltersApi.configuration,
  });

export const useCrmFilterFields = () => {
  const { data: crmFiltersData } = useCrmFilters();

  const isCrmTrueLocationFieldAndSearchEnabled =
    useCrmTrueLocationFieldAndSearchEnabled();

  return useMemo(() => {
    if (!crmFiltersData?.filter_configurations) {
      return [];
    }

    if (!isCrmTrueLocationFieldAndSearchEnabled) {
      return [];
    }

    return crmFiltersData.filter_configurations.reduce(
      (acc: RenderFilter[], filter) => {
        const Component =
          crmFilterComponents[
            filter.input_type as keyof typeof crmFilterComponents
          ];
        if (Component) {
          acc.push({
            name: filter.key,
            component: Component,
            label: filter.label,
            configuration: filter,
          });
        }
        return acc;
      },
      [],
    );
  }, [crmFiltersData, isCrmTrueLocationFieldAndSearchEnabled]);
};
